import { Divider, FormControl, MenuItem, Select } from '@mui/material';

const HeaderFilterSelect = ({ label, value, onChange, options, totalCount, allLabel = 'Todos', minWidth = 120 }) => (
  <FormControl variant="standard" sx={{ minWidth, width: '100%' }}>
    <Select
      value={value}
      onChange={onChange}
      displayEmpty
      disableUnderline
      renderValue={() => label}
      sx={{
        width: '100%',
        fontSize: 14,
        fontWeight: 600,
        color: value ? 'primary.main' : 'text.primary',
        pr: 0.5,
        '& .MuiSelect-select': {
          py: 0,
          pr: '18px !important',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }
      }}
    >
      <MenuItem value="">{`${allLabel} (${totalCount})`}</MenuItem>
      {options.flatMap((option) => {
        const menuItem = (
          <MenuItem key={option.value} value={option.value}>
            {option.label} ({option.count ?? 0})
          </MenuItem>
        );
        if (!option.divider) return [menuItem];
        return [
          <Divider key={`divider-${option.value}`} component="li" sx={{ my: 0.5 }} />,
          menuItem,
        ];
      })}
    </Select>
  </FormControl>
);

export default HeaderFilterSelect;